/**
 * Barra inferior móvil THCC (sections/thcc-barra-inferior.liquid).
 * 1. Mantiene al día el contador del carrito: escucha el mismo evento que usa Horizon
 *    (StandardEvents.cartLinesUpdate, ver assets/cart-icon.js) y, como respaldo, consulta /cart.js al
 *    volver desde el historial.
 * 2. La barra queda siempre visible (no se oculta al hacer scroll).
 * 3. El destino de carrito abre el carrito lateral de Horizon (#cart-drawer) cuando existe; sin él
 *    navega a /cart como cualquier enlace.
 */
const SELECTOR = '[data-thcc-cart-count]';

/** @param {number} count */
function paint(count) {
  const safe = Number.isInteger(count) && count >= 0 ? count : 0;
  for (const el of document.querySelectorAll(SELECTOR)) {
    el.textContent = safe > 99 ? '99+' : String(safe);
    el.hidden = safe === 0;
    const link = el.closest('a');
    if (link) {
      const base = link.getAttribute('data-thcc-label') || '';
      link.setAttribute('aria-label', safe > 0 ? `${base}, ${safe}` : base);
    }
  }
}

async function refreshFromServer() {
  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!response.ok) return;
    const cart = await response.json();
    paint(cart.item_count);
  } catch (_) {
    // Sin red: se conserva el valor renderizado por Liquid.
  }
}

async function init() {
  if (!document.querySelector(SELECTOR)) return;

  try {
    const { StandardEvents } = await import('@shopify/events');
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      const promise = /** @type {any} */ (event).promise;
      if (promise && typeof promise.then === 'function') {
        promise
          .then(({ cart, detail }) => paint(cart?.totalQuantity ?? detail?.itemCount ?? 0))
          .catch(() => refreshFromServer());
      } else {
        refreshFromServer();
      }
    });
  } catch (_) {
    // El mapa de importaciones no resolvió: queda el respaldo de pageshow.
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshFromServer();
  });
}

/* ---------- 3. Carrito lateral ---------- */

function initCart() {
  for (const link of document.querySelectorAll('[data-thcc-carrito]')) {
    link.addEventListener('click', (event) => {
      if (/** @type {MouseEvent} */ (event).defaultPrevented) return;
      const drawer = /** @type {any} */ (document.getElementById('cart-drawer'));
      const open = drawer?.open ?? drawer?.toggle;
      if (typeof open !== 'function') return;
      event.preventDefault();
      open.call(drawer);
    });
  }
}

init();
initCart();
